export function initApp() {
    return {type: "INIT_APP"}
}

export function setAppLoading(isLoading) {
    return {type: 'SET_LOADING', payload: isLoading}
}
